import { render, staticRenderFns } from "./DefaultLayout_HeaderFix.vue?vue&type=template&id=83950a6a&scoped=true"
import script from "./DefaultLayout_HeaderFix.vue?vue&type=script&lang=js"
export * from "./DefaultLayout_HeaderFix.vue?vue&type=script&lang=js"
import style0 from "./DefaultLayout_HeaderFix.vue?vue&type=style&index=0&id=83950a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83950a6a",
  null
  
)

export default component.exports